export default "__VITE_ASSET__BnkeAWvF__"